export const LOW_BALANCE_THRESHOLD = 50
const STORAGE_KEY = 'transport-low-balance-reminder-session'
let lastShownSession = ''

export function availableBalanceForReminder (account) {
  const value = account && account.availableBalance
  if (!['number', 'string'].includes(typeof value) || String(value).trim() === '') return null
  const amount = Number(value)
  return Number.isFinite(amount) ? amount : null
}

export function claimLowBalanceReminder (session) {
  if (!session || lastShownSession === session) return false
  try {
    if (window.sessionStorage.getItem(STORAGE_KEY) === session) {
      lastShownSession = session
      return false
    }
  } catch (error) { /* memory fallback when browser storage is unavailable */ }
  lastShownSession = session
  try { window.sessionStorage.setItem(STORAGE_KEY, session) } catch (error) { /* memory fallback */ }
  return true
}
